import { createSlice } from "@reduxjs/toolkit";

// Split into pending and active filters.
const initialState = { open: false };
const appHeaderSearch = createSlice({
    name: "appHeaderSearch",
    initialState,
    reducers: {
        openAppHeaderSearch(state): void {
            // State can be modified directly when inside createSlice
            state.open = true;
        },
        closeAppHeaderSearch(state): void {
            state.open = false;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = appHeaderSearch;
// Extract and export each action creator by name
export const { openAppHeaderSearch, closeAppHeaderSearch } = actions;
// Export the reducer, either as a default or named export
export default reducer;
